import { Link } from 'react-router-dom';

// @mui material components
import MuiLink from '@mui/material/Link';
import { Box, Typography } from '@mui/material';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';

const FilledInfoCard = ({
    variant = 'contained',
    color = 'info',
    icon,
    title,
    description,
    action = false,
}) => {
    const buttonStyles = {
        width: 'max-content',
        display: 'flex',
        alignItems: 'center',

        '& .MuiSvgIcon-root': {
            fontSize: '1.125rem',
            transform: `translateX(3px)`,
            transition: 'transform 0.2s cubic-bezier(0.34, 1.61, 0.7, 1.3)',
        },

        '&:hover .MuiSvgIcon-root, &:focus .MuiSvgIcon-root': {
            transform: `translateX(6px)`,
        },
    };

    const gradient = {
        backgroundImage: `linear-gradient(to right bottom, rgba(125, 121, 112, 0.8), rgba(204, 203, 202, 0.8))`,
    };

    let iconColor = color;

    if (variant === 'gradient' && color !== 'light') {
        iconColor = 'white';
    } else if (variant === 'gradient' && color === 'light') {
        iconColor = 'dark';
    }

    return (
        <Box
            display={{ xs: 'block', md: 'flex' }}
            borderRadius={3}
            pt={3.5}
            pb={3}
            px={3}
            //sx={variant === 'gradient' && gradient}
        >
            <Typography
                display='block'
                variant='h3'
                color={iconColor}
                //textGradient={variant === 'contained'}
                mt={-0.625}
            >
                {icon}
            </Typography>
            <Box pt={{ xs: 3, md: 0 }} pl={{ xs: 0, md: 2 }} lineHeight={1}>
                <Typography
                    display='block'
                    variant='5'
                    color={
                        variant === 'contained' || color === 'light'
                            ? 'dark'
                            : 'white'
                    }
                    fontWeight='bold'
                    mb={1}
                >
                    {title}
                </Typography>
                <Typography
                    display='block'
                    variant='body2'
                    color={
                        variant === 'contained' || color === 'light'
                            ? 'text'
                            : 'white'
                    }
                    mb={2}
                >
                    {description}
                </Typography>
                {action && action.type === 'external' ? (
                    <Typography
                        component={MuiLink}
                        href={action.route}
                        target='_blank'
                        rel='noreferrer'
                        variant='body2'
                        fontWeight='regular'
                        color={variant === 'contained' ? color : 'white'}
                        sx={buttonStyles}
                    >
                        {action.label} <TrendingFlatIcon fontWeight='bold' />
                    </Typography>
                ) : null}
                {action && action.type === 'internal' ? (
                    <Typography
                        component={Link}
                        to={action.route}
                        variant='body2'
                        fontWeight='regular'
                        color={variant === 'contained' ? color : 'white'}
                        sx={buttonStyles}
                    >
                        {action.label} <TrendingFlatIcon fontWeight='bold' />
                    </Typography>
                ) : null}
            </Box>
        </Box>
    );
};

export default FilledInfoCard;
